<template>
    <div style="height: 100%; width: 100%;">
            <div v-if="semItensNoCarrinho">
                <p class="texto-desabilitado">
                    Você ainda não possui produtos no seu carrinho.
                </p>
            </div>

        <!-- card branco com cada iten do carrinho  --> 
        <div class="corpo" >

            <!-- iterar sobre todos os itens do carrinho --> 
            <div v-for="(item, index) in carrinho" :key="index">


                <!-- ------------------------------------------------------caso o item seja PRODUTO ou MERCADORIA--------------------------------------------------------  -->
                <div v-if="item.subitens == null && item.subitem == null">
                    <CardItemCarrinho :item="item" :onExcluir="deletarItem" :onEditar="editarItem" :temSubitem="false"/>
                </div>
        

                <!--                                                   **  ATENCAO  **                                                                            -->
                <!--                                                                                                                                              -->
                <!--                                                   **  COMBOS  **                                                                             -->
                <!--                                                                                                                                              -->
                <!--           os combos venda conjunta  tem a chave SUBITENS (plural)    - pois vem todos os itens da venda conjunta                             -->
                <!--           os combos por tamanho     tem a chave SUBITEM (singular)   - pois vem apenas o item escolhido do combo                             -->
                <!--           os combos pizza           tem a chave SUBITEM (singular)   - vem as chaves: {borda: item, massa:item, sabores: Array<item> }       -->

                <!-- ------------------------------------------------------caso o item seja COMBO VENDA CONJUNTA --------------------------------------------------------  -->
                <div v-if="item.tipo == 'comboVendaConjunta'" class="card-comboVendaConjunta"> 
                    <!-- iterar nsobre cada subitem do combo  -->   
                    <div class="combo-nome-precototal">
                        <p class="texto-nome-combo">{{ item.nome }}</p>
                    </div>
                    <!-- <hr class="combo-title-hr">  -->
                    <div class="combo-itens-agrupador">
                        <div v-for="(cadaSubItem, indexx) in item.subitens" :key="indexx"> 
                            <CardItemCarrinho :item="cadaSubItem" :onExcluir="deletarItemCombo" :onEditar="editarItemCombo" :temSubitem="true" :combo="item"/>   
                        </div>
                    </div>
                </div>

                <!-- ------------------------------------------------------ caso o item seja COMBO POR TAMANHO --------------------------------------------------------  -->
                <div v-if="item.tipo == 'comboPorTamanho'" class="card-comboPorTamanho">
                    <div class="combo-nome-precototal">
                        <p class="texto-nome-combo">{{ item.nome }}</p>
                    </div>
                    <!-- <hr class="combo-title-hr"> -->
                    <div class="combo-itens-agrupador">
                        <div>
                            <CardItemCarrinho :item="item.subitem" :onExcluir="deletarItem" :onEditar="editarItemCombo" :temSubitem="true" :combo="item"/>
                        </div>
                    </div>
                </div> 

                <!-- ------------------------------------------------------ caso o item seja COMBO PIZZA --------------------------------------------------------  -->
                <div v-if="item.tipo == 'comboPizza'" class="card-comboPizza">
                    <div class="combo-nome-precototal">
                        <p class="texto-nome-combo">{{ item.nome }}</p>
                        <p class="texto-nome-combo">R$ {{  (item.preco).toFixed(2).replace(".", ",")}}</p>
                    </div>

                    <!-- <hr class="combo-title-hr"> -->

                    <div class="combo-itens-agrupador">
                        <!-- sabores  -->
                        <div v-if="item.subitens.sabores != null && item.subitens.sabores.length > 0">
                            <CardSaborPizzaCarrinho :sabores="item.subitens.sabores" :saborMaisCaro="buscarPrecoPizzaSaberMaisCaro(item.subitens.sabores)" :precoPizza="item.precoPizza" :onExcluir="deletarItemCombo" :onEditar="editarItemCombo" :temSubitem="true" :combo="item"/>   
                        </div>

                        <!-- borda  -->
                        <div v-if="item.subitens.borda.id != null && item.subitens.borda != {}">
                            <CardItemCarrinho :item="item.subitens.borda" :onExcluir="deletarItemCombo" :onEditar="editarItemCombo" :temSubitem="true" :combo="item"/>
                        </div>
                        
                        <!-- massa  -->
                        <div v-if="item.subitens.massa.id != null && item.subitens.massa != {}">
                            <CardItemCarrinho :item="item.subitens.massa" :onExcluir="deletarItemCombo" :onEditar="editarItemCombo" :temSubitem="true" :combo="item"/>
                        </div>
                        
                    </div>
                </div>

                <!-------------------------------------------------------- caso o item seja COMBO POR ETAPAS --------------------------------------------------------  -->
                <div v-if="item.tipo == 'comboPorEtapa'">
                        <div v-if="item.subitens.length===1">
                            <!-- Caso tenha so 1 subitem vai ter aparencia de um item fora do combo -->
                            <div v-for="(cadaSubItem, indexx) in item.subitens" :key="indexx"> 
                                <CardItemCarrinho :item="cadaSubItem" :onExcluir="deletarItemCombo" :onEditar="editarItemCombo" :temSubitem="true" :combo="item"/>   
                            </div>
                        </div>
                        <div v-else>
                            <div class="card-comboPorEtapa">
                                <div class="combo-nome-precototal">
                                    <p class="texto-nome-combo">{{ item.nome }}</p>
                                    <p class="texto-nome-combo">R$ {{ (item.preco).toFixed(2).replace(".", ",")}}</p>
                                </div>
                                <!-- <hr class="combo-title-hr"> -->
                                <!-- subitens  -->
                                <div class="combo-itens-agrupador">
                                    <div v-for="(cadaSubItem, indexx) in item.subitens" :key="indexx"> 
                                        <CardItemCarrinho :item="cadaSubItem" :onExcluir="deletarItemCombo" :onEditar="editarItemCombo" :temSubitem="true" :combo="item"/>   
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            
            </div>
        </div>
    </div>
</template>

<script>
import CardItemCarrinho from "./CardItemCarrinho.vue"
import CardSaborPizzaCarrinho from "./CardSaborPizzaCarrinho.vue";
export default {
    name: "ListaItensCarrinho",
    components: {
        CardItemCarrinho,CardSaborPizzaCarrinho
    },
    props: {
        semItensNoCarrinho: Boolean,
        carrinho: Array,
        deletarItem: Function,
        deletarItemCombo: Function,
        editarItem:Function,
        editarItemCombo:Function
    },
    created() {
        this.consologar()
    },
    methods: {
        consologar() {},
        buscarPrecoPizzaSaberMaisCaro(sabores) {
            let itens = [...sabores]
            itens.sort((a, b) => Number(b.preco) - Number(a.preco))
            return Number(itens[0].preco)
        },
        }
}
</script>

<style scoped>
.texto-nome-combo {
    font-size: 15px;
    margin: 0px; 
    font-weight: 900; 
    text-align: start;
}
.corpo {
    max-height: 100%;
    height: 100%;
    /* padding-block: 15px; */
    padding-inline: var(--padding-padrao);
}
.corpo>div{
    padding-top: var(--padding-padrao);
}

.combo-itens-agrupador {
    border-left: solid white 1px;
    border-bottom: solid white 1px;
    border-end-start-radius: 3px;
}
.combo-itens-agrupador> div{
    padding-bottom: var(--padding-padrao);
}

.combo-nome-precototal {
    display: flex;
    justify-content: space-between;
    padding-block: var(--padding-padrao);
    padding-left: 2px;
}


.card-comboPizza, .card-comboPorEtapa, .card-comboVendaConjunta, .card-comboPorTamanho {
    background: var(--cinza-claro);
    border: 1px var(--cinza-escuro) solid;
    color: black;
    border-radius: var(--border-radius-padrao);
    padding-inline: var(--padding-padrao);
}

.combo-title-hr {
    margin: 0;
    height: 0;
    padding: 0;
    border-top: 1px solid #ccc;
}
</style>